import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import { isNil } from 'lodash'
import {
  getEventFundsList,
  getEventFundsListV2,
  getEventSortFilters,
} from '../../actions/events'
import { CATEGORY_MANAGER } from '../../constants/types/categories'
import http from '../../utils/api'
import { getSummitFundAttendeeDefaultColumns } from '../../utils/columns'
import ContextTable from '../ContextTable'

const SummitAttendeeFunds = ({
  eventId,
  isPast,
  isVirtual,
  defaultFilterValue,
}) => {
  const [data, setData] = useState(null)
  const [refreshData, setRefreshData] = useState(false)
  const [columns, setColumns] = useState(null)

  const refresh = () => {
    setRefreshData(!refreshData)
  }

  useEffect(() => {
    const cols = getSummitFundAttendeeDefaultColumns(isPast, refresh, isVirtual)

    getEventSortFilters(eventId, CATEGORY_MANAGER)
      .then((res) => {
        const query = res.data

        if (!isNil(query.sorter) && !isNil(query.sorter.columnKey)) {
          const sortIndex = cols.findIndex(
            (x) =>
              x.dataIndex === query.sorter.columnKey ||
              x.key === query.sorter.columnKey
          )
          if (sortIndex >= 0) {
            cols[sortIndex].defaultSortOrder = query.sorter.order
          }
        }

        if (!isNil(query.filters) && !isNil(query.filters.columns)) {
          let filterIndex

          for (let i = 0; i < query.filters.columns.length; i++) {
            filterIndex = cols.findIndex(
              (x) =>
                x.dataIndex === query.filters.columns[i].column ||
                x.key === query.filters.columns[i].column
            )

            if (filterIndex >= 0) {
              cols[filterIndex].defaultFilteredValue =
                query.filters.columns[i].values
            }
          }
        }

        setColumns(cols)
      })
      .catch((err) => setColumns(cols))
  }, [refreshData])

  const getSavedQuery = () => getEventSortFilters(eventId, CATEGORY_MANAGER)

  return (
    <>
      {columns && (
        <ContextTable
          tableTitle="Funds"
          columns={columns}
          eventId={eventId}
          dataMethod={getEventFundsListV2}
          savedQueryMethod={getSavedQuery}
          refresh={refreshData}
          refreshData={refreshData}
          scroll={{ x: true }}
          defaultSearchTerm={defaultFilterValue}
        />
      )}
    </>
  )
}

SummitAttendeeFunds.propTypes = {
  eventId: PropTypes.number.isRequired,
}
export default SummitAttendeeFunds
